// extracted by mini-css-extract-plugin
module.exports = {"projectImage":"ProjectImage_projectImage__xS-BS"};